import {useNavigate} from 'react-router-dom';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import UserCard from '../../../../components/mazraeKit/cards/userCard';
import DotsLoading from '../../../../components/dotsLoading';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

interface ICustomersPointProps {
  setOpenAddPoints: React.Dispatch<React.SetStateAction<boolean>>;
  guid?: string;
  commentsListIsLoading: boolean;
  commentsList?: ICommentss;
}

const CustomersPoint = ({
  setOpenAddPoints,
  guid,
  commentsList,
  commentsListIsLoading,
}: ICustomersPointProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col w-full gap-2">
      <div className="flex w-full items-center justify-between text-md font-medium mb-4">
        <h5 className="text-md flex items-center m-0 p-0 text-gray-700">
          دیدگاه مشتریان
        </h5>
        <button
          className="flex text-sm items-center text-farm-shop-500"
          onClick={() => {
            navigate(`/comments-listing/${guid}`);
            googleAnalyticsInstance.eventGoogleAnalytics({
              category: 'allComments',
              action: 'کاربر روی مشاهده ده دیدگاه دیگر از جزییات شاپ کلیک کرد',
            });
          }}
        >
          مشاهده دیدگاه دیگر
          <SpanIcon className="icon-nameArrow---Left-2 text-lg" />
        </button>
      </div>
      {commentsListIsLoading ? (
        <div className="flex w-full justify-center">
          <DotsLoading />
        </div>
      ) : (
        <>
          {commentsList?.results && commentsList?.results.length !== 0 && (
            <div className="w-full flex gap-2 h-[170px] items-center overflow-x-auto pr-4 ">
              {commentsList?.results?.map(
                (item: ICommentsResults, index: number) => (
                  <UserCard
                    rate={item.rate}
                    key={index}
                    description={item.text}
                    name={item.user}
                    timeDate={item.created_at}
                    cardWrapperClassName="w-[296px]"
                  />
                ),
              )}
            </div>
          )}
        </>
      )}
      <button
        className="text-farm-shop-500 border-[1px] border-farm-shop-500 rounded-[8px] h-[40px]"
        onClick={() => {
          setOpenAddPoints(true);
          googleAnalyticsInstance.eventGoogleAnalytics({
            category: 'registerComments',
            action: 'کاربر روی ثبت دیدگاه از جزییات شاپ کلیک کرد',
          });
        }}
      >
        دیدگاه خود را ثبت کنید
      </button>
    </div>
  );
};

export default CustomersPoint;
